import { render, staticRenderFns } from "./KpiValue.vue?vue&type=template&id=24d1ddc3&"
import script from "./KpiValue.vue?vue&type=script&lang=js&"
export * from "./KpiValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports